import React from 'react';
import { useParams } from 'react-router-dom';
import { ROPatientContextProvider } from '../PatientSummary/context';
import OuterContainer from '../PatientSummary/OuterContainer';
import ChatContainer from './components/ChatPanel';
const ChatPage = (): JSX.Element => {
  const { id: patientId } = useParams<{ id: string }>();

  return (
    <ROPatientContextProvider>
      <OuterContainer marginBottom="0px" rowSpace="0px">
        <ChatContainer patientId={patientId} />
      </OuterContainer>
    </ROPatientContextProvider>
  );
};

export default ChatPage;
